import React from "react";
import { motion } from "framer-motion";

const chapters = [
    { n: "I.", title: "Weak or inconsistent Wi-Fi.", copy: "Guests complain, POS terminals drop, and no one owns the fix. We map coverage, tune equipment and separate the networks that should never share a lane." },
    { n: "II.", title: "Disorganized cables and equipment.", copy: "Tangled racks, unlabelled cables and phantom devices from previous tenants. We clean up, label, document and photograph so nothing is guesswork later." },
    { n: "III.", title: "Unreliable TVs or digital signage.", copy: "Menu boards go dark. Content players freeze. Screens are mounted where the sun destroys them. We install commercial displays and content systems that survive real conditions." },
    { n: "IV.", title: "Audio that hurts on a busy night.", copy: "Speakers in the wrong zones, volume that spikes between tracks, sources you can't hear. We install zoned audio that respects the room." },
    { n: "V.", title: "Multiple vendors, unclear responsibility.", copy: "Your IT company points at your AV vendor who points at your ISP. We coordinate all of them so you have one point of contact." },
    { n: "VI.", title: "Last-minute opening delays.", copy: "The technology piece gets left until three days before opening. We plan it into the project schedule so it's ready when you are." },
    { n: "VII.", title: "No one to call when something stops working.", copy: "You shouldn't have to gamble on a search result at 6pm on a Friday. Our support plans give you a known relationship, not a stranger." },
];

export default function Manifesto() {
    return (
        <section data-testid="manifesto" className="bg-panel text-bg relative grain grain-dark">
            <div className="max-w-[1440px] mx-auto px-6 md:px-10 py-20 md:py-32">
                <div className="grid md:grid-cols-12 gap-10 mb-14">
                    <div className="md:col-span-5">
                        <p className="eyebrow text-bg/40 mb-6">Seven problems we hear every week</p>
                        <h2 className="font-display text-4xl md:text-6xl leading-[0.95] tracking-tight">
                            Technology should support your business — not slow it down.
                        </h2>
                    </div>
                    <div className="md:col-span-6 md:col-start-7 self-end">
                        <p className="text-bg/70 leading-relaxed text-base md:text-lg">
                            These are the recurring headaches Metro Vancouver operators bring to us. Every chapter below is one thing we're paid to make quieter.
                        </p>
                    </div>
                </div>

                <div className="border-t border-line-2">
                    {chapters.map((c, i) => (
                        <motion.div
                            key={c.n}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.6, delay: i * 0.04 }}
                            className="border-b border-line-2 py-10 md:py-14 grid md:grid-cols-12 gap-8 group"
                        >
                            <div className="md:col-span-1 font-mono text-sm text-bg/50 tracking-widest">{c.n}</div>
                            <h3 className="md:col-span-6 font-display text-2xl md:text-4xl tracking-tight text-bg group-hover:text-gold transition-colors duration-500">{c.title}</h3>
                            <p className="md:col-span-5 text-bg/70 leading-relaxed">{c.copy}</p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
}
